// removed by extract-text-webpack-plugin
module.exports = {"RoomDescription":"roomInfo__RoomDescription__16_n9","TabNameTitle":"roomInfo__TabNameTitle__1Oa1P","ToggleView":"roomInfo__ToggleView__15P6I","InstructionsContainer":"roomInfo__InstructionsContainer__3LKDE","Collapsed":"roomInfo__Collapsed__1O1QJ","InstructionsTitle":"roomInfo__InstructionsTitle___j8j7","CopiedContainer":"roomInfo__CopiedContainer__1f6ud","CopyRow":"roomInfo__CopyRow__1VFCO","CopyIcon":"roomInfo__CopyIcon__Mdhch","LinkContainer":"roomInfo__LinkContainer__k7zTH"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/roomInfo.css
// module id = 1083
// module chunks = 2